export default __webpack_public_path__ + "static/media/IconRecordSires.39e9c357.svg";